import { Utilities as U } from '@shared/utilities/utilities.model';
import { CasualType, WorkingTypes } from './enums.model';

// Utilizzata in authority-dossier-workings-list.component.ts
export class DossierWorking {

	id		    							: string = '';        
	working_id							: string = '';        
	working_number_prefix	  : string = '';    // NUMERO PRATICA
	type										: WorkingTypes;   // AMBITO
	dossier_id							: string = '';        
	created_at							: string = '';    // DATA CREAZIONE
	plate								    : string;         // TARGA
	causal_type							: CasualType;     // CAUSALE
	status									: EWorkingStates; // STATO
	username								: string = '';    // OPERATORE
	commodity_id						: string = '';
	ald_commodity_id				: string = '';    // il BE non lo restituisce
	dossier_number				  : string = '';
	updated_at				      : string = '';
	first_approved_at				: string = '';
	
	// TODO
	// da togliere e gestire tutto dentro un TableListComponent
	// guardare sul branch feature/NEMOGUI-1966__bis
	// utile per la selezione multipla 
	selected?	      			  : boolean = false;
	
	// Controlla se la pratica dev'essere da ri-approvare
	// (es: il centro assistenza aggiunge un ricambio in fase di integrazione)
	isReApproved?	      	  : boolean = false;
	archived?	          	  : boolean = false;
	
	constructor(model?: any) {

		if (U.isEmpty(model)) {
			return;
		}

		// Object.assign(this, model);
		this.id         					 = model.working_id;
		this.working_id 					 = model.working_id;
		this.working_number_prefix = model.working_number_prefix;
		this.dossier_id 					 = model.dossier_id;
		this.created_at 					 = model.created_at;
		this.plate 					   		 = model.plate;
		this.username 						 = model.username;
		this.commodity_id 				 = model.commodity_id;
		this.type 		   					 = model.type as WorkingTypes;     
		this.causal_type 					 = model.causal_type as CasualType;
		this.status      					 = model.status as EWorkingStates; 
		this.ald_commodity_id 		 = model.ald_commodity_id;
		this.dossier_number    		 = model.dossier_number;
		this.updated_at    				 = model.updated_at;
		this.first_approved_at   	 = model.first_approved_at
		this.selected    				   = model.selected;
		
		this.isReApproved    			 = model.first_approved_at != null && model.status === EWorkingStates.APPROVING;
		this.archived    				   = model.archived;
	}

	setArchived(archived: boolean): void {
		this.archived = archived;
	}

	/**
	 * Indica se la pratica è chiusa-archiviato
	 * La pratica archiviata non può essere canalizzata
	 * 
	 * @returns {boolean}
	 */
	isArchived(): boolean {
		// return true;
		return !!this.archived;
	}

	/**
	 * Restituisce la lista degli stati finali dell'entità
	 * 
	 * @returns {EWorkingStates[]}
	 */
	static getFinalStatusList(): EWorkingStates[] {
		return [ EWorkingStates.CLOSED ];
	}
}

export enum EWorkingStates {
	TO_ESTIMATE 											= 'TO_ESTIMATE',
	TO_SEND 													= 'TO_SEND',
	PRE_AUTHORITY_REJECTED 						= 'PRE_AUTHORITY_REJECTED',
	TO_CHANNEL 												= 'TO_CHANNEL',
	APPROVING 												= 'APPROVING',
	DECLINED 													= 'DECLINED',
	REJECTED 													= 'REJECTED',
	WAITING_FOR_UNFREEZE 							= 'WAITING_FOR_UNFREEZE',
	WAITING_FOR_ACCEPTANCE 						= 'WAITING_FOR_ACCEPTANCE',
	SUPERVISOR_APPROVING 							= 'SUPERVISOR_APPROVING',
	SUPERVISOR_REJECTED 							= 'SUPERVISOR_REJECTED',
	WAITING_PARTS 										= 'WAITING_PARTS',
	RE_APPROVING 											= 'RE_APPROVING',
	RE_DECLINED 											= 'RE_DECLINED',
	C_FLOW_APPROVING 									= 'C_FLOW_APPROVING',
	C_FLOW_REJECTED 									= 'C_FLOW_REJECTED',
	WAITING_FOR_WORKING 							= 'WAITING_FOR_WORKING',
	ADMINISTRATIVE_WORKING 						= 'ADMINISTRATIVE_WORKING',
	WORKING 													= 'WORKING',
	INTEGRATION_TO_SEND 							= 'INTEGRATION_TO_SEND',
	CLOSED_WITH_LIQUIDATION 					= 'CLOSED_WITH_LIQUIDATION',
	CLOSED_WITH_REJECTION 						= 'CLOSED_WITH_REJECTION',
	ADMINISTRATIVE_WAITING_FOR_CLOSED = 'ADMINISTRATIVE_WAITING_FOR_CLOSED',
	ADMINISTRATIVE_REJECTED 					= 'ADMINISTRATIVE_REJECTED',
	CLOSED 														= 'CLOSED',
	
	/**
	 *  Stato inserito con performance archiviazione
	 *  le pratiche chiuse hanno un periodo di retention
	 *  (30 giorni) in cui rimangono nel DB Attivo.
	 * 
	 * 	Finito il periodo viene passata nel DB Archivio.
	 * 
	 *  18/03/2025 - gli stati finti non esistono più neanche a FE
	 * 
	 */
	// CLOSED_TO_BE_ARCHIVED             = "CLOSED_TO_BE_ARCHIVED",
}


	/**
	 *  Pratica da canalizzare 
	 *  serve solo a livello interno
	 *  prima di creare il DTO
	 */
export class DossierWorkingToChannel { 
	workingId    : string;
	workingType? : WorkingTypes;
	archived?    : boolean;

	constructor(model?: any) {

		if (U.isEmpty(model)) {
			return;
		}

		this.workingId   = model.workingId;
		this.workingType = model.workingType;
		this.archived    = model.archived;
	}
};